import { CalendarDays, Clock } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { imgSrc, scrollToSection } from "../../lib/api";

const MONTHS = ["GEN", "FEB", "MAR", "APR", "MAG", "GIU", "LUG", "AGO", "SET", "OTT", "NOV", "DIC"];

function parseDate(d) {
  const dt = new Date(`${d}T00:00:00`);
  if (isNaN(dt)) return null;
  return { day: dt.getDate(), month: MONTHS[dt.getMonth()], weekday: dt.toLocaleDateString("it-IT", { weekday: "short" }).toUpperCase() };
}

export function EventsSection({ events, onBook }) {
  if (!events.length) return null;

  return (
    <section id="eventi" className="py-24 sm:py-32" data-testid="events-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>Eventi & Serate</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <SectionTitle className="mt-4">
            Le prossime <em className="italic text-gold-glow">serate</em>
          </SectionTitle>
        </Reveal>

        <div data-testid="events-list-container" className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {events.map((ev, i) => {
            const d = parseDate(ev.date);
            return (
              <Reveal key={ev.id} delay={i * 0.08}>
                <article data-testid={`event-card-${ev.id}`} className="group h-full bg-card2 border border-white/10 hover:border-gold/30 rounded-2xl overflow-hidden transition-colors duration-300 flex flex-col">
                  {ev.image && (
                    <div className="relative h-44 overflow-hidden">
                      <img src={imgSrc(ev.image)} alt={ev.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-108" />
                      <div className="absolute inset-0 bg-gradient-to-t from-card2 via-transparent to-transparent" />
                      {ev.tag && (
                        <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-[0.2em] bg-burgundy-brand/90 text-cream px-3 py-1.5 rounded-full border border-gold/30">
                          {ev.tag}
                        </span>
                      )}
                    </div>
                  )}
                  <div className="p-6 flex gap-5 flex-1">
                    {d && (
                      <div className="shrink-0 text-center border-r border-white/10 pr-5">
                        <p className="font-num text-3xl font-bold text-gold-glow leading-none">{d.day}</p>
                        <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.25em] text-cream-muted">{d.month}</p>
                        <p className="mt-1 text-[9px] uppercase tracking-[0.2em] text-cream-subtle">{d.weekday}</p>
                      </div>
                    )}
                    <div className="min-w-0 flex flex-col">
                      <h3 className="font-serif text-xl text-cream leading-snug">{ev.title}</h3>
                      {ev.time && (
                        <p className="mt-1.5 inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-copper">
                          <Clock className="w-3 h-3" /> ore {ev.time}
                        </p>
                      )}
                      {ev.description && <p className="mt-2.5 text-sm text-cream-muted font-light leading-relaxed">{ev.description}</p>}
                      <button
                        data-testid={`event-book-${ev.id}`}
                        onClick={() => { onBook({ date: ev.date, time: ev.time, notes: `Evento: ${ev.title}` }); scrollToSection("#prenota"); }}
                        className="mt-4 self-start inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-gold-glow hover:text-cream border border-gold/40 hover:border-gold rounded-full px-5 py-2.5 transition-colors"
                      >
                        <CalendarDays className="w-3.5 h-3.5" /> Prenota per questa serata
                      </button>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
